export default __webpack_public_path__ + "static/media/a024-6.b72967bb.svg";